import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component InvoicesIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <InvoicesIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <InvoicesIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const InvoicesIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="InvoicesIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path d="M15.19 4H5v16h14V7.891zM5 2h11.03L21 7.075V20a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m4.974 11.752q-.015.798.42 1.26t1.078.588v-2.926a3 3 0 0 0-.448-.126 11 11 0 0 1-1.022-.329 3.3 3.3 0 0 1-.903-.504 2.3 2.3 0 0 1-.637-.784q-.238-.469-.238-1.169 0-.714.273-1.26t.721-.917a3.3 3.3 0 0 1 1.036-.574 4.7 4.7 0 0 1 1.218-.245V5.688h.826v1.078q.63.07 1.183.273t.973.56.686.889q.266.533.308 1.26H13.46a1.47 1.47 0 0 0-.35-.952q-.336-.392-.812-.392v2.478l.343.084a9 9 0 0 1 .371.098q1.036.28 1.596.693t.826.861.315.896q.05.448.049.798 0 .308-.154.777a2.6 2.6 0 0 1-.553.917q-.399.449-1.071.798t-1.722.42v1.19h-.826v-1.19q-1.568-.112-2.45-.966Q8.14 15.403 8 13.752zm2.324 1.848q.252-.028.525-.119a1.6 1.6 0 0 0 .49-.259 1.4 1.4 0 0 0 .357-.413q.14-.245.14-.581 0-.546-.343-.819t-1.169-.497zm-.826-7.196a1.5 1.5 0 0 0-.462.07 1.2 1.2 0 0 0-.406.217q-.182.148-.287.364-.105.217-.105.511 0 .462.294.714t.966.406z" />
      <path
        stroke="#F4F5F7"
        strokeWidth={0.1}
        d="M.05.05h23.9v23.9H.05z"
        opacity={0.01}
      />
    </svg>
  )
);
InvoicesIcon.displayName = "InvoicesIcon";
export default InvoicesIcon;
